import React, { useEffect, useState } from "react";
import {Breadcrumb, Button, Form} from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import Layout from "../../components/layouts/layout";
import loginCheck from "../../helpers/loginCheck";
import http from "../../http";
import "./role.css";
import {useLang} from "../../hooks";
import {BackButton} from "../../components/BackButton/BackButton";

const RoleCreate = () => {
  const { register, handleSubmit } = useForm();
  const [data, setData] = useState("");
  const [roles, setRoles] = useState("");
  const [keyss, setKeys] = useState([]);
  const [valuess, setvalues] = useState([]);
  const [getSuccess, setSuccess] = useState(false);
  const [getError, setError] = useState("");
  const [getErrorObj, setErrorObj] = useState({});
  const [permissions, setPermissions] = useState([]);
  const [getLoader, setLoader] = useState(false);
  const cookies = new Cookies();
  const {t} = useLang();

  const navigate = useNavigate();

  useEffect(() => {
    if (!loginCheck()) {
      navigate("/login");
    }
  });

  useEffect(() => {
    fetchAllPermissions();
  }, []);

  const fetchAllPermissions = () => {
    http
      .get("/permission/admin/all", {
        headers: {
          Authorization: "Bearer " + cookies.get("userAuth").token,
        },
      })
      .then((res) => {
        setPermissions(res.data.data);
      });
  };
  const onSubmit = (data, e) => {
    data = { ...data, ...roles };
    data.user_id = cookies.get("userAuth").id;
    setLoader(true);
    http
      .post("/role/create", data, {
        headers: {
          Authorization: "Bearer " + cookies.get("userAuth").token,
        },
      })
      .then((res) => {
        // setSuccess(true);
        localStorage.setItem("success", true);
        // setLoader(false);
        setTimeout(() => {
          navigate("/role");
        }, 1000);
      })
      .catch((err) => {
        setLoader(false);
        // console.log(Object.keys(err.response.data.data))
        let errs = err.response.data.data;
        let keys = Object.keys(errs);
        let errors = {};
        keys.map((key) => (errors[key] = errs[key][0]));
        console.info(errors);
        setError(err.response.data);

        setErrorObj(errors);
      });
  };
  const onError = (errors, e) => console.log(errors, e);

  const handleChange = (e) => {
    console.log(e);
    let role = { ...roles };
    role[e.target.name] = e.target.value;
    setRoles(role);
  };
  return (
    <>
      <Layout>
        {getLoader && (
            <div className="preloader">
              <div className="overlay__inner">
                <div className="overlay__content">
                  <span className="spin"></span>
                </div>
              </div>
            </div>
        )}
        <header>
          <div className="d-flex justify-content-between">
            <Breadcrumb>
              <li className="breadcrumb-item">
                <Link to={`/role`}> {t("acl_roleList_roleList")}</Link>
              </li>
              <Breadcrumb.Item active>
                {t("acl_createRole_createRole")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <BackButton path={-1} text={t("acl_roleList_roleList")}/>
          </div>
        </header>
        <div className="form_design">
          <h2 style={{color: "black", textDecoration: "underline"}}>
            {t("acl_createRole_createRole")}
          </h2>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group>
              <Form.Label className="form_label mark-required">{t("acl_createRole_name")}</Form.Label>
              <Form.Control
                  type="text"
                  name="name"
                  placeholder={t("acl_createRole_name_plhd")}
                  onChange={(e) => handleChange(e)}
              />
              {getErrorObj.name ? (
                  <span className="text-danger">{getErrorObj.name}</span>
              ) : null}
            </Form.Group>

            {/* <Form.Group>
                    <Form.Label className="form_label">Permission</Form.Label>
                    <CheckPicker  name="holiday" 
                        data={keys?.map((item,ele) => ({ label: day[item], value: ele }))} 
                        style={{ width: "100%" }} 
                        //   {...register("dr_speciality_id")} 
                        onChange={(value) => setHolidays({...holidays, "holiday": value})} 
                    />

                    {getErrorObj.days? 
                    <span className="text-danger">
                    {getErrorObj.days}
                    </span> : null
                    }
                </Form.Group> */}

            <div className="mt-4">
              <Button className="action__btn" variant="primary" type="submit">
                {t("acl_createRole_save")}
              </Button>
              <Link to="/role">
                <Button className="action__btn" variant="info">
                  {t("acl_createRole_backToHome")}
                </Button>
              </Link>
            </div>
          </Form>
        </div>
      </Layout>
    </>
  );
};

export default RoleCreate;

